export default __webpack_public_path__ + "static/media/product-11.f696743e.webp";